export class ShareReference  {
    model: string | null = null;
    pathid!: string;
    modelNode: any;

    constructor (modelNode: any) {
        this.modelNode = modelNode;
        this.setNodeReference();
    }

    clone() {
        return new ShareReference(this.modelNode);
    }

    getReferenceData() {

        if (this.modelNode.entity && this.model) {
            return { pathid: this.pathid, model: this.model };
        } else {
            return { pathid: this.pathid };
        }
    }

    getModelNodeData() {

        if (this.modelNode && this.modelNode.metadata && this.modelNode.metadata.data) {
            return this.modelNode.metadata.data;
        }

        return null;
    }

    setNodeReference() {

        if (this.modelNode.entity) {
           this.model = this.modelNode.hsbmodel.modelId;
           this.pathid = this.modelNode.entity.handle;
        } else {
            this.pathid = this.modelNode.pathid;
        }
    }
}
